module.exports = __webpack_public_path__ + "static/media/color2.b383ea8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/color2.jpg
// module id = 798
// module chunks = 0